/**
 * @desc 同步报告推送状态
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.PushReportRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/synchronousPush`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
